import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import PastYear2526 from './pages/PastYear/PastYear2526';
import PastYear2324 from './pages/PastYear/PastYear2324';
import PastYear2122 from './pages/PastYear/PastYear2122';
import PastYear2021 from './pages/PastYear/PastYear2021';
import PastYear1819 from './pages/PastYear/PastYear1819';
import Process from './pages/Process';
import OurTeam from './pages/OurTeam';
import Fleet from './pages/Fleet';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import './responsive.css';
const App: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                
                <Route path="pastyear2526" element={<PastYear2526 />} />
                <Route path="pastyear2324" element={<PastYear2324 />} />
                <Route path="pastyear2122" element={<PastYear2122 />} />
                <Route path="pastyear2021" element={<PastYear2021 />} />
                <Route path="pastyear1819" element={<PastYear1819 />} />
                <Route path="our-team" element={<OurTeam />} />
                <Route path="fleet" element={<Fleet />} />
                <Route path="contact" element={<Contact />} />
                <Route path="gallery" element={<Gallery />} />
                <Route path="blog" element={<Blog />} />
                <Route path="blog/:slug" element={<BlogPost />} />
                <Route path="process" element={<Process />} />
            </Route>
        </Routes>
    );
};

export default App;
